import React from 'react';
import '../styles/Contact.scss';
import CmykMark from '../common_components/design_components/CmykMark';
import ContactForm from '../common_components/ContactForm'; 
import Mark from '../common_components/design_components/Mark';
import CmykVert from '../common_components/design_components/CmykVert';

const Contact = () => {
  return (
    <div className="contact-page">
      {/* Left Section */}
      <div className="contact-left">
        <div className="contact-title">
          <h1>CONTACT</h1>
          <CmykMark />
        </div>
      </div>

      {/* Right Section */}
      <div className="contact-right">
        <ContactForm /> {/* Reusable Contact Form Component */}

        <p className="contact-alt">
          You can try the old fashioned way or directly at <br />
          <a href="mailto:jakeruleaux@gmail.com">jakeruleaux@gmail.com</a>
        </p>
      </div >
      <div className="cmyk-vert">
        <CmykVert />
      </div>
      <div className="registration-mark top-left">
        <Mark />
      </div>
      <div className="registration-mark bottom-left">
        <Mark />
      </div>
    </div>
  );
};

export default Contact;
